import React from 'react';

function Intro() {
    return (
        <header>
            <h1>Mininova web editor</h1>
            <p>Control your Novation Mininova synth from your web browser</p>
        </header>
    );
}

export default Intro;
